export default __webpack_public_path__ + "static/media/pink-expand-collapse.3fcdf4bf.svg";